import { IonPage, useIonViewWillEnter } from '@ionic/react';
import { RouteComponentProps } from 'react-router';
import { AppHeader, IconArrowLeft, IconButton } from '@mindly/ui-components';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuthFlow } from '../../shared';
import { PrivateRoutes, PublicRoutes } from '../../routes/navigation';
import { ProfileCountryOfLivingWidget } from '../../widgets';
import { authStateSelector } from '../../redux/auth/selector';
import { resetAuthState } from '../../redux/auth/reducer';
import { loadConsultationsThunk } from '../../redux/consultations/action';
import { fetchSubscriptions } from '../../redux/subscriptions/thunk';
import { usePushNotifications } from '../../shared/context/PushNotificationsContext';
import { userSelector } from '../../redux/user/selector';
import { useUser } from 'src/shared/hooks/useUser';

type NeedUpdatePersonalDataCountryOfLivingPageProps = RouteComponentProps;

export function NeedUpdatePersonalDataCountryOfLivingPage({ history }: NeedUpdatePersonalDataCountryOfLivingPageProps) {
  const authData = useSelector(authStateSelector);
  const user = useSelector(userSelector);

  const { authUser } = useAuthFlow();
  const dispatch = useDispatch();
  const pushNotificationsState = usePushNotifications();
  const { redirectToOnboarding } = useUser();

  useIonViewWillEnter(() => {
    if (!authUser) {
      history.push(PublicRoutes.AUTH);
      return;
    }
  }, []);

  const handleSuccess = useCallback(async () => {
    if (!authData.isNeedAdditionalData) {
      history.push(PrivateRoutes.NEED_UPDATE_PERSONAL_DATA_SUCCESS);
    } else {
      if (authData.action === 'signUp') {
        const isRedirectToOnboarding = await redirectToOnboarding();
        if (isRedirectToOnboarding) return;
        history.push(authData.redirectTo ? authData.redirectTo : PrivateRoutes.PSYCHOLOGIST_LIST);
      } else if (authData.action === 'signIn') {
        if (authData.redirectTo) {
          history.push(authData.redirectTo);
        } else if (user) {
          const consultations = await dispatch(loadConsultationsThunk(user.id));
          await dispatch(fetchSubscriptions(user.id));
          localStorage.removeItem('onboardingToken');
          const isRedirectToOnboarding = await redirectToOnboarding();
          if (isRedirectToOnboarding) return;
          history.replace(
            consultations?.length && !(user.id !== authData.onBoardingUserId && authData.newOnBoardingAnswers)
              ? PrivateRoutes.CONSULTATION
              : PrivateRoutes.PSYCHOLOGIST_LIST
          );
          pushNotificationsState.setIsOpenPushNotificationModal(
            pushNotificationsState.pushNotificationStatus === 'prompt'
          );
        }
      }
      dispatch(resetAuthState());
    }
  }, [history, authData, pushNotificationsState, user]);

  return (
    <IonPage>
      <AppHeader className="flex flex-row items-start mb-4 cursor-pointer">
        <IconButton
          icon={<IconArrowLeft />}
          onClick={() => history.push(PrivateRoutes.NEED_UPDATE_PERSONAL_DATA_DOB)}
        />
      </AppHeader>
      <ProfileCountryOfLivingWidget onSuccess={handleSuccess} />
    </IonPage>
  );
}
